import React, { useRef, useEffect } from 'react';
import DropdownMenuItem from './DropdownMenuItem';
import { CgProfile } from "react-icons/cg";
import { MdSettings } from 'react-icons/md';
import SignOut from '../SignOut';

const DropdownMenu = ({ onClose, onProfileClick, onSettingsClick, onSignOut }) => {
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  return (
    <div
      ref={dropdownRef}
      className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg z-10"
    >
      <DropdownMenuItem onClick={onProfileClick} icon={CgProfile} label="Profile" />
      <DropdownMenuItem onClick={onSettingsClick} icon={MdSettings} label="Settings" />
      <SignOut onSignOut={onSignOut} />
    </div>
  );
};

export default DropdownMenu;
